export const aboutSections = [
  {
    title: "🧩 About This Website",
    contentFunc: () => (
      <p>Welcome to a space designed for <strong>relaxation and fun</strong> through a simple yet engaging game: the <strong>Schulte Table</strong>. Whether you're here to test your cognitive skills or just unwind, this site has something for you! Click below and scroll down to learn more! 👇</p>
    ),
  },
  {
    title: "🎮 What is a Schulte Table?",
    contentFunc: () => (
      <>
      <p>The <strong>Schulte Table</strong> is a cognitive exercise invented by German psychotherapist <strong>Walter Schulte</strong>. It’s a classic game that sharpens focus and mental agility. The goal is straightforward:</p>
      <ul>
        <li><strong>Click the numbers in sequence</strong>, starting from 1 up to 16 (or the highest number based on your chosen grid size).</li>
      </ul>
      </>
    ),
  },
  {
    title: "🛠️ Features",
    contentFunc: () => (
      <>
      <p>Customize your experience with these flexible settings and features:</p>
      <ul><li><p><strong>Game Settings Panel</strong>:</p><ul><li><strong>Grid Size</strong>: Choose the number of tiles to suit your preference.</li><li><strong>Game Modes</strong>: Try exciting variations beyond the classic game:<ul><li><strong>Reaction Mode</strong>: Tiles hide, revealing only the one you're supposed to click.</li><li><strong>Memory Mode</strong>: Tiles are briefly visible to help you memorize their positions before they disappear.</li><li><strong>Line Mode</strong>: Tiles are only shuffled on a row by row basis.</li></ul></li><li><strong>Direction</strong>: Select the order of play:<ul><li>Default: Numbers ascend (e.g., 1 → 2 → 3...).</li><li>Reverse: Numbers descend (e.g., 16 → 15 → 14...).</li></ul></li></ul></li><li><p><strong>Personal Statistics</strong>:</p><ul><li>Track your <strong>Personal Best Record</strong>.</li><li>Review the stats of your <strong>most recent game</strong>.</li></ul></li><li><p><strong>Screen Controls</strong>:</p><ul><li>Toggle between <strong>Light</strong> and <strong>Dark themes</strong> for your preferred look.</li><li>Hide the <strong>Settings</strong> and <strong>Statistics panels</strong> for distraction-free gameplay.</li></ul></li></ul>
      </>
    ),
  },
  {
    title: "🌟 Why Play Here?",
    contentFunc: () => (
      <p>This website is all about enjoying a simple game while relaxing. Whether you're a competitive player chasing records or just here to pass time, you'll find a smooth and enjoyable experience.</p>
    ),
  },
  {
    title: "🌐 Open Source and Beyond",
    contentFunc: () => (
      <>
      <p>This is an <strong>open-source project</strong>, free for everyone to use.</p>
      <ul><li>Explore the <strong>source code</strong> on GitHub by clicking the <em>See Source Code</em> button.</li><li>Interested in my other projects? Visit my <strong>personal website</strong> through the <em>Visit My Website</em> button to learn more!</li></ul>
      </>
    ),
  },
  {
    title: "🎉 Have Fun!",
    contentFunc: () => (
      <>
      <p>Dive in, challenge yourself, and enjoy playing the Schulte Table. Happy gaming! 😊</p>
      </>
    ),
  },
];
